import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminUserRoutingModule } from './admin-user-routing.module';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
@NgModule({
  declarations: [ListComponent, AddComponent],
  imports: [
    CommonModule,
    AdminUserRoutingModule
  ]
})
export class AdminUserModule { }
